import {useState,useEffect} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import {
	applyRecipeUpdatesToMeals,
	reorderRecipeFoods,
	editRecipeMacro,
	selectRecipeById,
	addRecipeMacros,
	removeRecipeFood,
	addTagToRecipe,
	editRecipeFood,
	updateViewer,
	removeRecipe,
	removeMacro,
	fetchByTag,
	editRecipe,
	createTag,
	deleteTag,
	readTags,
} from './recipesSlice'
import {useDebounceCallback} from '@react-hook/debounce'
import useS3DirectUpload from '../../hooks/useS3DirectUpload'
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch'
import {ellipsis} from '../../util/util'
import ResourceLibrary from '../ResourceLibrary/Library'
import {update as updateResourceLibrary} from '../ResourceLibrary/slice'

import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'

import css from './Recipes.module.css'

import CreatableSelect from 'react-select/creatable'
import { components } from "react-select"

import {Link,useHistory} from 'react-router-dom'

import {
	DragDropContext,
	Droppable,
	Draggable,
} from 'react-beautiful-dnd'

import MacroTotals from './MacroTotals'

import FoodPortionSelect from '../FoodPortionSelect/FoodPortionSelect'

const Food = ({food,quantity,position,optional,id,idx,recipeId,initialPortionId})=>{

	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()

	const handleChangeQty = e => {
		statusDispatch(editRecipeFood({
			id,update:{quantity:e.target.value},
			recipeId
		}),'food','edit')
	}

	const handleChangePortion = portion => {
		statusDispatch(editRecipeFood({
			id,update:{food_db_portion_id:portion.id},
			recipeId
		}),'food','edit')
	}

	const handleChangeOptional = e => {
		statusDispatch(editRecipeFood({
			id,update:{is_optional:Number(e.target.checked)},
			recipeId
		}),'food','edit')
	}

	const {show:showLibrary,replace} = useSelector(state=>state.resourceLibrary)
	const isReplacing = showLibrary && replace.type === 'food' && replace.id === id

	const handleRemoveFood = ()=>{
		if (!window.confirm('Are you sure you want to remove this food?')) return
		statusDispatch(removeRecipeFood({id,recipeId}),'food','delete')
	}

	const handleReplace = ()=>{
		dispatch(updateResourceLibrary({
			show:true,
			resourceType:'food',
			tgtResourceType:'recipe',
			tgtResourceId:recipeId,
			replace:{
				type:'food',
				id
			}
		}))
	}

	//destructure macros per unit
	const {calories,protein,fat,carbs} = food

	return (
		<Draggable
			key={`recipe-food-${id}`}
			draggableId={`recipe-food-${id}`}
			index={idx}
		>
			{(provided, snapshot) => (
				<div 
					ref={provided.innerRef}
					{...provided.draggableProps}
					className={css.FoodContainer}
				>
					<div {...provided.dragHandleProps} className={css.DragHandle}>
						<i className="fa fa-grip-vertical"/>
					</div>
					<div className={css.Food}>
						<div>
							<div 
								onClick={handleReplace}
								className={css.FoodName}>
								{isReplacing&&<i className="fa fa-exchange-alt mr-1 text-primary"/>}
								{food.food_db_name}
							</div>
							<FoodPortionSelect
								onChange={handleChangePortion}
								portions={food.portions}
								initialPortionId={initialPortionId}
								qty={quantity}
							/>
						</div>
						<div className="ml-md-auto d-flex align-items-center" style={{flex:'0 0 auto'}}>
							<small className="mr-2">Qty:</small>
							<Form.Control 
								placeholder="quantity"
								className="mr-2"
								onChange={handleChangeQty}
								size="sm" 
								defaultValue={quantity}
							/>
							<Form.Check 
								onChange={handleChangeOptional}
								style={{flex:'0 0 auto'}}
								id={`is-optional-${id}`}
								label="Optional"
								defaultChecked={Boolean(optional)}
							/>
							<Button 
								onClick={handleRemoveFood}
								variant="outline-danger" 
								className="ml-2" 
								size="sm"
							>
								<i className="fa fa-trash"/>
							</Button>
						</div>
					</div>
				</div>
			)}
		</Draggable>
	)
}

const MacroCreator = ({recipeId,setShowMacroCreator})=>{
	const dispatch = useDispatch()
	const [macro,setMacro] = useState('')
	const [unit,setUnit] = useState('')
	const [isSaving,setIsSaving] = useState(false)
	const handleSave = ()=>{
		setIsSaving(true)
		dispatch(addRecipeMacros({
			recipe_id:recipeId,
			macros:[{macro,unit,qty:1}]
		})).then(()=>{
			setMacro('')
			setUnit('')
			setIsSaving(false)
			setShowMacroCreator(false)
		})
	}

	const handleCancel = ()=>{
		setMacro('')
		setUnit('')
		setShowMacroCreator(false)
	}
	return (
		<div className="p-3 rounded border my-2">
			<small>Macro Name</small>
			<Form.Control 
				onChange={e=>{
					setMacro(e.target.value)
				}}
				value={macro}
				size="sm"
			/>
			<small>Macro Unit</small>
			<Form.Control 
				onChange={e=>{
					setUnit(e.target.value)
				}}
				value={unit}
				size="sm"
			/>
			<div className="mt-2 text-right">
				<Button 
					disabled={isSaving}
					onClick={handleCancel}
					variant="outline-danger" 	
					size="sm"
				>
					Cancel
				</Button>
				<Button 
					onClick={handleSave}
					disabled={isSaving||!Boolean(macro)||!Boolean(unit)}
					variant="outline-success" 	
					className="ml-2"
					size="sm"
				>
					Add to Recipe {isSaving&&<Spinner animation="border" size="sm"/>}
				</Button>
			</div>
		</div>
	)
}

const Macro = ({macro})=>{
	const dispatch = useDispatch()
	const handleRemove = ()=>{
		if(!window.confirm('Are you sure you want to remvoe this macro?')) return
		dispatch(removeMacro(macro))
	}
	const handleEdit = (update)=>{
		dispatch(editRecipeMacro({
			recipeId:macro.recipe_id,
			id:macro.id,
			update
		}))
	}

	const debouncedEdit = useDebounceCallback(
		handleEdit,
		500
	)

	return (
		<div className="d-flex align-items-end mb-2 pb-2" style={{borderBottom:'1px solid #ccc'}}>
			<div className="mr-2">
				<small className="d-block">Name</small>
				<Form.Control
					onChange={e=>{
						debouncedEdit({
							macro:e.target.value
						})
					}}
					placeholder="unit"
					defaultValue={macro.macro}
					size="sm"
				/>
			</div>
			<div className="mr-2">
				<small className="d-block">Quantity</small>
				<Form.Control
					onChange={e=>{
						debouncedEdit({
							qty:e.target.value
						})
					}}
					placeholder="quantity"
					defaultValue={macro.qty}
					size="sm"
				/>
			</div>
			<div className="mr-2">
				<small className="d-block">Unit</small>
				<Form.Control
					onChange={e=>{
						debouncedEdit({
							unit:e.target.value
						})
					}}
					placeholder="unit"
					defaultValue={macro.unit}
					size="sm"
				/>
			</div>
			<Button 
				className="ml-auto"
				onClick={handleRemove}
				variant="outline-danger"
				size="sm"
			>
				<i className="fa fa-trash"/>
			</Button>
		</div>
	)
}

const MenuList = ({ children, ...props }) => {
	return (
		<components.MenuList {...props}>
			<div >
				<i className="ml-2 m-0 pt-3 fa fa-info-circle">  </i> <span><i> To create a new tag, enter a unique name above </i> </span>
				<hr />


			</div>
			{children}

		</components.MenuList>

	);
}

const Placeholder = ({name})=>(
	<div className="py-1 mb-2 text-center rounded border">
		Adding {name} <Spinner animation="border" size="sm"/>
	</div>
)

const Editor = ({location})=>{
	const history = useHistory()
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()
	const params = new URLSearchParams(location.search)
	const id = params.get('id')
	const recipe = useSelector(state => selectRecipeById(state,id))
	const {processUpload} = useS3DirectUpload()
	const tags = useSelector(state=>state.recipes.tags)

	const isDefault = parseInt(recipe?.owner_id) === 999999

	//if no recipe there's a chance that the user reloaded
	//if this is the case then fetch all recipes and try one
	//more time. if there is still no recipe that we can assume
	//the recipe does not exist and display "not found"
	const [fetched,setFetched] = useState(false)

	const [newImage,setNewImage] = useState('')
	const [savingImage,setSavingImage] = useState(false)
	const [showMacroCreator,setShowMacroCreator] = useState(false)

	const [isCopyingDefault,setIsCopyingDefault] = useState(false)
	const handleEdit = update => {
		setIsCopyingDefault(isDefault)
		//if editing a default recipe lock all inputs 
		const payload = {
			recipe_id:id,
			...update
		}
		return statusDispatch(
			editRecipe(payload),
			'recipe',
			'edit'
		).then((res)=>{
			setIsCopyingDefault(false)
			history.replace(`recipe-editor?id=${res.payload.data.recipe.id}`)
		})
	}

	const handleRemoveRecipe = ()=>{
		if (!window.confirm('Are you sure you want to delete this recipe?')) return 
		dispatch(updateViewer({show:false,id:null}))
		dispatch(removeRecipe({recipe_id:id}))
		history.push('/recipeList')
	}

	const handleApplyUpdates = ()=>{
		if (!window.confirm('Are you sure you want to update ALL MEALS using this recipe?')) return
		dispatch(applyRecipeUpdatesToMeals({recipe_id:id}))
	}

	const debouncedEdit = useDebounceCallback(
		handleEdit,
		400
	)

	useEffect(()=>{
		dispatch(readTags())
	},[])

	if (!recipe) {
		if (!fetched) {
			dispatch(
				fetchByTag({ 
					action: 'readRecipes', 
					tags: [] 
				})
			)
			return (
				<div>Loading recipe data...</div>
			)
		} else {
			return (
				<div>No recipe found with that id</div>
			)
		}
	}

	const showLibrary = ()=>{
		dispatch(updateResourceLibrary({
			show:true,
			resourceType:'food',
			tgtResourceType:'recipe',
			tgtResourceId:id,
			replace:{}
		}))
	}

	const handleDragEnd = (result)=>{
		if (recipe.foods.length < 2) return
		const {source:{index:srcIdx},destination:{index:tgtIdx}} = result
		if (srcIdx===tgtIdx) return

		//get a temp array with the src item removed
		const tmpNoSrc = [
			...recipe.foods.slice(0,srcIdx),
			...recipe.foods.slice(srcIdx+1)
		]

		//define the update with the src item at the target index
		//perform deep copy "hack" so we can mutate the update object
		//with the new foods orders
		const update = JSON.parse(JSON.stringify([
			...tmpNoSrc.slice(0,tgtIdx),
			recipe.foods[srcIdx],
			...tmpNoSrc.slice(tgtIdx)
		]))

		//update the foods orders to reflect the new order
		update.forEach((food,i)=>{
			food.routine_order = i+1
		})

		const ids = update.map(f=>f.id)
		dispatch(reorderRecipeFoods({
			recipeId:id,
			update,
			new_order:ids
		}))
	}

	const handleRemoveImage = ()=>{
		if(!window.confirm('Are you sure you want to remove this image?')) return
		setSavingImage(true)
		handleEdit({image:''}).then(()=>{
			setSavingImage(false)
		})
	}

	const handleUploadImage = async ()=>{
		setSavingImage(true)
		const s3Res = await processUpload(newImage)
		handleEdit({
			image:s3Res.payload.url
		}).then(()=>{
			setSavingImage(false)
			setNewImage('')
		})
	}

	const handleAddTagToRecipe = ({name,tag_id})=>{
		dispatch(addTagToRecipe({
			recipe_id:id,
			tag_id,
			name,
		}))
	}

	const handleRemoveTagFromRecipe = ({name,tag_id})=>{
		dispatch(deleteTag({
			recipe_id:id,
			tag_id
		}))
	}

	const handleCreateTag = (name)=>{
		dispatch(
			createTag({name})
		).then((res)=>{
			const newTag = res.payload.data
			handleAddTagToRecipe({
				name:newTag.name,
				tag_id:newTag.id
			})
		})
	}

	return (
		<>
			<ResourceLibrary/>
			{/*
				Add a bunch of white space at the bottom so that 
				we can scroll the last food into center of screen
			*/}
			<div style={{
				paddingBottom:'400px',
				width:'800px',
				maxWidth:'90%',
				margin:'auto'
			}}>
				<Link to="/recipeList">Back to Recipes</Link>
				<hr className="my-1" />
				<strong className="d-block">Recipe Editor</strong>
				{isDefault&&
					<Alert className="text-dark" variant="warning">
						<i className="fas fa-exclamation-circle mr-1"/>
						You are editing a default recipe. Edits will create a copy that belongs to you. The first change may take a few seconds.
					</Alert>
				}
				<div>
					<strong>Name</strong>
					<Form.Control 
						disabled={isCopyingDefault}
						onChange={ e => {
							debouncedEdit({name:e.target.value})
						}}
						defaultValue={recipe.name}
					/>
				</div>
				<div className="my-2">
					{(Boolean(recipe.image)&&!Boolean(newImage))&&
						<>
							<img 
								className="d-block mb-2"
								style={{
									objectFit:'cover',
									maxWidth:'100%',
									height:'200px'
								}}
								src={recipe.image}
							/>
							<div className="mb-2">
								<Button 
									disabled={savingImage||isCopyingDefault}
									onClick={handleRemoveImage}
									variant="outline-danger"
									size="sm"
								>
									Remove Image
								</Button>
								{savingImage&&
									<Spinner animation="border" size="sm"/>
								}
							</div>
						</>
					}
					{Boolean(newImage)&&
						(
							<>
								<img 
									className="d-block mb-2"
									style={{
										objectFit:'cover',
										maxWidth:'100%',
										height:'200px'
									}}
									src={URL.createObjectURL(newImage)}
								/>
								<div className="mb-2">
									<Button 
										onClick={()=>{
											setNewImage('')
										}}
										disabled={savingImage||isCopyingDefault}
										variant="outline-danger"
										className="mr-2"
										size="sm"
									>
										{Boolean(recipe.image)?'Use Original':'Remove Image'}
									</Button>
									<Button 
										disabled={savingImage||isCopyingDefault}
										onClick={handleUploadImage}
										variant="outline-success"
										size="sm"
										className="mr-2"
									>
										Save Image
									</Button>
									{savingImage&&<Spinner animation="border" size="sm"/>}
								</div>
							</>
						)
					}
					<Form.File 
						disabled={isCopyingDefault}
						onChange={e=>{
							setNewImage(e.target.files[0])
						}}
						id="recipe-image"
						label="Recipe Image"
						custom
					/>
				</div>
				<div className="d-flex align-items-end">
					<div className="w-50 mr-2">
						<strong>Serving Size</strong>
						<Form.Control 
							disabled={isCopyingDefault}
							defaultValue={recipe.serving_size}
							onChange={ e => {
								debouncedEdit({serving_size:e.target.value})
							}}
							placeholder="Serving Size"
						/>
					</div>
					<div className="w-50">
						<strong>Number of Servings</strong>
						<Form.Control 
							disabled={isCopyingDefault}
							defaultValue={recipe.num_servings}
							onChange={ e => {
								debouncedEdit({num_servings:e.target.value})
							}}
							placeholder="Number of servings"
						/>
					</div>
				</div>
				<div>
					<strong>Description</strong>
					<Form.Control 
						disabled={isCopyingDefault}
						onChange={ e => {
							debouncedEdit({description:e.target.value})
						}}
						defaultValue={recipe.description}
						as="textarea"
					/>
				</div>
				<div>
					<strong>Toppings or Add Ins</strong>
					<Form.Control 
						disabled={isCopyingDefault}
						onChange={ e => {
							debouncedEdit({add_ins:e.target.value})
						}}
						defaultValue={recipe.add_ins}
						as="textarea"
					/>
				</div>
				<div>
					<strong className="d-block">Ingredients</strong>
					<small>
						<i className="fa fa-info-circle mr-1"/>
						You can add custom ingredients here or use foods that are part of your library. Foods from your library will have macro totals automatically calculated.
					</small>
					<Form.Control 
						disabled={isCopyingDefault}
						onChange={ e => {
							debouncedEdit({ingredients:e.target.value})
						}}
						defaultValue={recipe.ingredients}
						as="textarea"
					/>
				</div>
				<div>
					<strong>Directions</strong>
					<Form.Control
						disabled={isCopyingDefault}
						onChange={e=>{
							debouncedEdit({directions:e.target.value})
						}}
						defaultValue={recipe.directions} 
						as="textarea"
					/>
				</div>
				<div>
					<strong>Recipe Link</strong>
					<Form.Control 
						disabled={isCopyingDefault}
						onChange={ e => {
							debouncedEdit({link:e.target.value})
						}}
						defaultValue={recipe.link}
					/>
				</div>
				<div>
					{
						recipe.foods.length > 0 
						? (
							<div>
								<div className="d-flex justify-content-between my-2">
									<strong>Foods</strong>
									<Button
										onClick={showLibrary}
										variant="outline-success"
										size="sm"
									>
										Add Foods to Recipe
									</Button>
								</div>
								<DragDropContext onDragEnd={handleDragEnd}>
									<Droppable droppableId="routine-list" type="EXERCISES">
										{(provided, snapshot) => (
											<div
												{...provided.droppableProps}
												ref={provided.innerRef}
											>
												{recipe.foods.map(
													({food,is_optional,quantity,recipe_position,id,recipe_id,type,food_db_name,food_db_portion_id},i) => (
														type === 'placeholder'
														? <Placeholder key={i} name={food_db_name} />
														: <Food
															initialPortionId={food_db_portion_id}
															position={recipe_position}
															optional={is_optional}
															recipeId={recipe_id}
															quantity={quantity}
															food={food}
															idx={i}
															key={id}
															id={id}
														/>
													)
												)}
												{provided.placeholder}
											</div>
										)}
									</Droppable>
								</DragDropContext>
							</div>
						)
						: (
							<div className="py-5">
								<Button
									onClick={showLibrary}
									variant="outline-success"
									size="lg"
									block
								>
									Add Foods to Recipe
								</Button>
							</div>
						)
					}
				</div>
				<div>
					<Form.Check 
						onChange={ e => {
							handleEdit({
								use_custom_macros:Number(e.target.checked)
							})
						}}
						checked={Boolean(recipe.use_custom_macros)}
						type="switch"
						id="custom-macro-switch"
						label="Use Custom Macros"
					/>
				</div>
				{Boolean(recipe.use_custom_macros)&&
					<div>
						<div className="mb-1 d-flex justify-content-between mt-2">
							<strong>
								Macro Nutrients
							</strong>
							<Button 
								variant="outline-success"
								onClick={()=>{
									setShowMacroCreator(true)
								}}
								size="sm"
							>
								Add Custom Macro Info
							</Button>
						</div>
						{showMacroCreator&&
							<MacroCreator 
								setShowMacroCreator={setShowMacroCreator}
								recipeId={id}
							/>
						}
						{Boolean(recipe.macros)&&
							recipe.macros.length > 0
							? recipe.macros.map(
								macro => <Macro key={macro.id} macro={macro} />
							)
							: (
								<small className="d-block py-3 text-center">
									No macros added yet.
								</small>
							)
						}
					</div>
				}
				<MacroTotals recipe={recipe} />
				<div>
					<strong className="d-block">Tags</strong>
					<CreatableSelect
						isMulti={true}
						isClearable
						onChange={(_,payload) => {  
							if (payload.action === 'remove-value') {
								const {removedValue:{label,value}} = payload
								handleRemoveTagFromRecipe({name:label,tag_id:value})
							} else {
								const {option:{label,value}} = payload
								handleAddTagToRecipe({name:label,tag_id:value})
							}
						}}
						components={{ MenuList }}
						onCreateOption={handleCreateTag}
						options={tags.map(item => ({ label: item.name, value: item.id }))}
						value={recipe.tags.map(item => ({ label: item.name, value: item.id }))}
						placeholder="Select Tag"
					/>
				</div>
				<div className="my-2 text-right">
					<Button 
						onClick={handleRemoveRecipe}
						variant="outline-danger"
						className="mr-2"
					>
						Delete Recipe
					</Button>
					<OverlayTrigger overlay={
						<Tooltip>
							Apply all changes made to this recipe to all meals that were created using this recipe.
						</Tooltip>
					}>
						<Button 
							onClick={handleApplyUpdates}
							variant="outline-info"
							className="mr-2"
						>
							Update All Meals Using This Recipe
						</Button>
					</OverlayTrigger>
					<Button 
						as={Link}
						to="/recipeList"
						//onClick={handleRemoveRecipe}
						variant="outline-success"
					>
						Done Editing
					</Button>
				</div>
			</div>
		</>
	)
}

export default Editor